export default "__VITE_ASSET__4cfd41ec__"